<script lang="ts">

  import { page } from "$app/state"
  import { APP_NAME } from "$lib/env"
  import { getLocalTimeZone, today } from "@internationalized/date"
  import Navigation from "../_components/navigation.svelte"
  import CardDate from "./_components/card-date.svelte"
  import CardProfile from "./_components/card-profile.svelte"
  import GridActivity from "./_components/grid-activity.svelte"
  import GridNews from "./_components/grid-news.svelte"
  import GridTimeTicker from "./_components/grid-time-ticker.svelte"
  import Menu from "./_components/menu.svelte"
  import MenuActivity from "./_components/menu-activity.svelte"
  import MenuActivityApproval from "./_components/menu-activity-approval.svelte"

  const prefix = $derived(page.params.prefix ?? "0")

  let date = $state(today(getLocalTimeZone()))

</script>

<main class="overflow-auto relative mx-auto h-full max-w-3xl">
  <nav class="sticky w-full top-0 inset-s-0 inset-e-0 z-10 bg-background border-b max-w-3xl">
    <div class="flex h-12 items-center justify-between px-3">
      <div class="flex items-center">
        <img
          src="/assets/logo.png"
          alt="logo"
          class="me-2 size-9"/>
        <h1 class="text-lg font-medium">{APP_NAME}</h1>
      </div>
      <div></div>
    </div>
  </nav>
  <div class="space-y-4">
    <div></div>
    <div class="mx-3 space-y-2">
      <CardProfile prefix={prefix}/>
      <GridTimeTicker/>
    </div>
    <CardDate
      value={date}
      onChange={(value) => (date = value)}/>
    <GridActivity
      prefix={prefix}
      date={date.toString()}/>
    <Menu prefix={prefix}/>
    <MenuActivity prefix={prefix}/>
    <MenuActivityApproval
      prefix={prefix}
      date={date.toString()}/>
    <GridNews prefix={prefix}/>
  </div>

  <div class="h-20"></div>
  <Navigation/>
</main>
